import CONSTANTS from './constants';
const navItems = {
    system: {
        iconClass: 'fa fa-cogs',
        name: {
            vi: 'Quản trị'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.SYSTEM],
        children: [
            {
                url: '/system/feedback',
                permissions: [CONSTANTS.USER_FUNCTIONS.SYSTEM],
                vi: 'Liên hệ',
                en: 'Feedback'
            },
        ]
    },
    userNav: {
        iconClass: 'fa fa-users',
        name: {
            vi: 'Người dùng'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.USER],
        children: [
            {
                url: '/user/group',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Nhóm người dùng',
                en: 'Group'
            },
            {
                url: '/user/user',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Người dùng',
                en: 'User'
            },
            {
                url: '/user/logs',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Nhật ký hệ thống',
                en: 'System logs'
            },
        ]
    },
    database: {
        viewName: 'database',
        iconClass: 'fa fa-database',
        name: {
            vi: 'Cơ sở dữ liệu'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
        children: [
            {
                url: '/database/base-map',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Bản đồ nền',
                en: 'Base map'
            },
            {
                url: '/database/data-layer',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Lớp dữ liệu',
                en: 'Data layer'
            },
            {
                url: '/database/point',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Điểm',
                en: 'Point'
            },
            {
                url: '/database/photo',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Hình ảnh',
                en: 'Image'
            },
            {
                url: '/database/general-info',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Thông tin chung',
                en: 'General information'
            },
            {
                url: '/database/tool',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Công cụ kỹ thuật',
                en: 'Tool'
            },
            {
                url: '/database/config',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Cấu hình',
                en: 'Config'
            },
        ]
    },
    newsNav: {
        viewName: 'news',
        iconClass: 'fa fa-newspaper-o',
        name: {
            vi: 'Tin bài'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.NEWS],
        children: [
            {
                url: '/news/news',
                permissions: [CONSTANTS.USER_FUNCTIONS.NEWS],
                vi: 'Tin tức',
                en: 'News'
            },
        ]
    }
};

export default navItems;
